import Constants from '../Constants';
import Configuration from './Configuration';

export function getIdentityManagementApiRoot(controller: string = Constants.MfaMultifactorController): string {
  const config = Configuration.Current();
  return `${config.identityManagementApiRoot}/${controller}/v1`;
}
